import { Middleware } from 'redux';

import { CALCULATE_SAVINGS } from './actions';
import { calculatedSavings } from './tracking';

export const trackingMiddleware: Middleware = ({
  getState,
}) => next => action => {
  switch (action.type) {
    case CALCULATE_SAVINGS:
      next(action);
      const state = getState();
      calculatedSavings(
        action.calculatorFormData,
        state.calculator.annualAmountSavings,
        action.calculatorFormData.isPageLoad
      );
      break;
  }
  return next(action);
};
